import { httpClient } from "../Common/httpClient";
import { getErrorMessage } from "../Common/Util";
import { Feedback } from "../Store/chatBotSlice";
import dashboardList from "./dashboards.json";

const resolveSelectedMarketForMiddleEast = () => {
  const dataSource =
    typeof window !== "undefined" && window.localStorage
      ? localStorage.getItem("DataSource")
      : null;

  if (dataSource !== "uae_mt") {
    return null;
  }

  const selectedMarket =
    typeof window !== "undefined" && window.localStorage
      ? localStorage.getItem("SelectedMarket") || "UAE MT"
      : "UAE MT";

  const validMiddleEastMarkets = ["UAE MT", "KSA MT"];
  if (!validMiddleEastMarkets.includes(selectedMarket)) {
    return "UAE MT";
  }

  return selectedMarket;
};

const appendMarketQueryForMiddleEast = (url: string) => {
  const selectedMarket = resolveSelectedMarketForMiddleEast();
  if (!selectedMarket) {
    return url;
  }

  if (url.includes("market=")) {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}market=${encodeURIComponent(selectedMarket)}`;
};

export async function getDashboardLists() {
  return dashboardList;
}

export async function getlatestSummary(payload: any) {
  // console.log("payload: ", payload);
  const dataSource =
    typeof window !== "undefined" && window.localStorage
      ? localStorage.getItem("DataSource")
      : null;
  const selectedMarket =
    typeof window !== "undefined" && window.localStorage
      ? localStorage.getItem("SelectedMarket") || "UAE MT"
      : "UAE MT";

  // Handle PTS POC separately with direct API call

  if (payload.projName === "PTS poc") {
    return httpClient
      .post("/pts_summary", payload, sessionStorage.getItem("accessToken")!)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.log("Error in chat bot service while getting PTS summary", err);
        return getErrorMessage(err);
      });
  }

  // Start the async task for Middle East markets (UAE MT / KSA MT)
  if (
    payload.projName === "UAE MT" ||
    payload.projName === "KSA MT" ||
    dataSource === "uae_mt"
  ) {
    const asyncPayload = {
      ...payload,
      projName:
        payload.projName === "UAE MT" || payload.projName === "KSA MT"
          ? payload.projName
          : selectedMarket,
    };
    // delete asyncPayload.market;

    const taskResponse = await httpClient
      .post(
        "/summary_sql_async",
        asyncPayload,
        sessionStorage.getItem("accessToken")!,
      )
      .then((res) => res)
      .catch((err) => {
        console.log(
          "Error in chat bot service while initiating the summary task",
          err
        );
        return getErrorMessage(err);
      });

    if (!taskResponse || !taskResponse.task_id) {
      throw new Error("Failed to start summary task");
    }

    // If backend already completed with cache, return immediately
    if (taskResponse.status === "completed") {
      return taskResponse;
    }

    const taskId = taskResponse.task_id;

    // Timeout limit (30 minutes)
    const startTime = Date.now();
    const timeoutLimit = 30 * 60 * 1000;

    // Poll for task completion
    while (true) {
      if (Date.now() - startTime > timeoutLimit) {
        throw new Error(
          "Sorry, that took too long. Please try your request again"
        );
      }

      const statusResponse = await httpClient
        .get("/task_status/" + taskId, sessionStorage.getItem("accessToken")!)
        .then((res) => res)
        .catch((err) => {
          console.log(
            "Error in chat bot service while checking task status",
            err
          );
          return getErrorMessage(err);
        });

      if (!statusResponse) {
        throw new Error("Failed to check task status");
      }

      if (statusResponse.status === "completed") {
        return statusResponse;
      } else if (statusResponse.status === "failed") {
        throw new Error(statusResponse.error || "Task failed");
      }

      // Wait before polling again
      await new Promise((resolve) => setTimeout(resolve, 20000));
    }
  }
   else {
    return httpClient
      .post("/summary_sql", payload, sessionStorage.getItem("accessToken")!)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.log(
          "Error in chat bot service while getting the summary of ai insights response",
          err
        );
        return getErrorMessage(err);
      });
  }
}
export async function uploadFile(body: FormData) {
    return httpClient.postUpload("/api/upload_file", body, sessionStorage.getItem("accessToken")!)
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            console.log("Error in While uploading the file in new dialog page", err);
            return getErrorMessage(err);
        });
}


export async function getPBIDashboards() {
    return httpClient.get("/pbi_dashboard", sessionStorage.getItem("accessToken")!)
        .then((res) => {
            return res;
        }).catch((err) => {
            console.log("Error while getting the PBI Dashboards list", err);
            return getErrorMessage(err);
        });
}

export async function saveChatHistory(req: any) {
  // Try up to 2 times before returning an error
  const token = sessionStorage.getItem("accessToken")!;
  for (let attempt = 1; attempt <= 2; attempt++) {
    try {
      // For the second attempt in UAE MT, send empty agent_metadata to avoid server-side failures
      let attemptReq = req;
      if (attempt === 2 ) {
        // do not mutate original req
        attemptReq = { ...req, agent_metadata: JSON.stringify([]) };
      }
      const res = await httpClient.post("/chat_history", attemptReq, token);
      return res;
    } catch (err) {
      console.log(`Error while saving the Chat history list (attempt ${attempt})`, err);
      if (attempt === 2) {
        return getErrorMessage(err);
      }
      // small delay before retrying
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
  }
}

export async function getChatHistory(email: string, isSpendWise = false) {
  const endpoint = appendMarketQueryForMiddleEast("/chat_history/" + email);
  return httpClient
    .get(
      endpoint,
      sessionStorage.getItem("accessToken")!,
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(
        "Error while getting the PBI Dashboards list by email:" + email,
        err,
      );
      return getErrorMessage(err);
    });
}


export async function saveLikeMessage(req: any) {
    return httpClient.put("/chat_history/feedback", req, sessionStorage.getItem("accessToken")!)
        .then((res) => {
            return res;
        }).catch((err) => {
            console.log("Error while saving the feeback", err);
            return getErrorMessage(err);
        });
}

export async function saveFeedback(req: any) {
    return httpClient.post("/feedback", req, sessionStorage.getItem("accessToken")!)
        .then((res) => {
            return res;
        }).catch((err) => {
            console.log("Error while saving the feeback reason", err);
            return getErrorMessage(err);
        });
}

export async function deleteRecentQueries(req: any) {
    return httpClient.put("/chat_history/delete", req, sessionStorage.getItem("accessToken")!)
        .then((res) => {
            return res;
        }).catch((err) => {
            console.log("Error while deleting the chat history", err);
            return getErrorMessage(err);
        });
}

export async function logEvent(req: any) {
    return httpClient.post("/log_event", req, sessionStorage.getItem("accessToken")!)
        .then((res) => {
            return res;
        }).catch((err) => {
            console.log("Error while saving the log event" + req.name, err);
            return getErrorMessage(err);
        });
}

export async function saveChat(req: any) {
    return httpClient.put("/chat_history/saved_chats", req, sessionStorage.getItem("accessToken")!)
        .then((res) => {
            return res;
        }).catch((err) => {
            console.log("Error while saving the chat response or summary response", err);
            return getErrorMessage(err);
        });
}

export async function getSavedChats(email: any, isSpendWise = false) {
  const endpoint = appendMarketQueryForMiddleEast(
    "/chat_history/saved_chats/" + email,
  );
  return httpClient
    .get(
      endpoint,
      sessionStorage.getItem("accessToken")!,
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(
        "Error while getting the saved chat list for the user ::" + email,
        err,
      );
      return getErrorMessage(err);
    });
}
export async function deleteSavedChats(req: any) {
    return httpClient.put("/chat_history/saved_chats/delete", req, sessionStorage.getItem("accessToken")!)
        .then((res) => {
            return res;
        }).catch((err) => {
            console.log("Error while deleting the saved chats", err);
            return getErrorMessage(err);
        });
}

export async function getAppUsage(dayCount: number) {
    return httpClient.get("/view/day_wise_event_summary/" + dayCount, sessionStorage.getItem("accessToken")!)
        .then((res) => {
            return res;
        }).catch((err) => {
            console.log("Error while getting the usage of the app ", err);
            return getErrorMessage(err);
        });
}

export async function getFiltersApi() {
  // Simple in-memory cache to avoid repeated network calls when filters are already loaded.
  // This keeps the last successful response for the lifetime of the page.
  // If a subsequent call occurs while a fetch is in-flight, return the same promise so
  // callers share the request.
  // Note: if you need TTL/invalidation, extend this logic.
  (getFiltersApi as any)._cache = (getFiltersApi as any)._cache || {};
  (getFiltersApi as any)._promise = (getFiltersApi as any)._promise || {};

  const selectedMarket = resolveSelectedMarketForMiddleEast() || "default";
  const cacheKey = selectedMarket;

  if ((getFiltersApi as any)._cache[cacheKey]) {
    return (getFiltersApi as any)._cache[cacheKey];
  }

  if ((getFiltersApi as any)._promise[cacheKey]) {
    return (getFiltersApi as any)._promise[cacheKey];
  }

  const token = sessionStorage.getItem("accessToken")!;
  const filtersEndpoint = appendMarketQueryForMiddleEast("/uae_mt_filters");
  // Try the filters endpoint, retrying once on failure before returning an error.
  const p = httpClient
    .get(filtersEndpoint, token)
    .then((res) => {
      // cache successful response
      (getFiltersApi as any)._cache[cacheKey] = res;
      (getFiltersApi as any)._promise[cacheKey] = null;
      return res;
    })
    .catch(async (err) => {
      console.warn(
        "First attempt to fetch /uae_mt_filters failed, retrying...",
        err
      );
      try {
        const res2 = await httpClient.get(filtersEndpoint, token);
        // cache successful retry
        (getFiltersApi as any)._cache[cacheKey] = res2;
        (getFiltersApi as any)._promise[cacheKey] = null;
        return res2;
      } catch (err2) {
        (getFiltersApi as any)._promise[cacheKey] = null;
        console.log("Error while getting the usage of the app ", err2);
        return getErrorMessage(err2);
      }
    });

  (getFiltersApi as any)._promise[cacheKey] = p;
  return p;
}

// Fetch filters scoped to a particular period and region selection.
// Accepts an object with keys: base_start, base_end, comp_start, comp_end, region (array or string)
export async function getFiltersBySelection(params: {
  base_start?: string;
  base_end?: string;
  comp_start?: string;
  comp_end?: string;
  region?: string | string[];
  category?: string | string[];
  sub_category?: string | string[];
}) {
  try {
    const qs: string[] = [];
    const hasValue = (value: unknown) => {
      if (Array.isArray(value)) {
        return value.some((item) => String(item ?? "").trim().length > 0);
      }
      return String(value ?? "").trim().length > 0;
    };

    if (params.base_start)
      qs.push("base_start=" + encodeURIComponent(params.base_start));
    if (params.base_end)
      qs.push("base_end=" + encodeURIComponent(params.base_end));
    if (params.comp_start)
      qs.push("comp_start=" + encodeURIComponent(params.comp_start));
    if (params.comp_end)
      qs.push("comp_end=" + encodeURIComponent(params.comp_end));
    if (params.region) {
      const regionValue = Array.isArray(params.region)
        ? params.region
            .map((item) => String(item ?? "").trim())
            .filter((item) => item.length > 0)
            .join(";")
        : params.region;
      qs.push("region=" + encodeURIComponent(regionValue));
    }
    if (typeof params.category !== "undefined" && hasValue(params.category)) {
      const catValue = Array.isArray(params.category)
        ? params.category
            .map((item) => String(item ?? "").trim())
            .filter((item) => item.length > 0)
            .join(";")
        : params.category;
      qs.push("category=" + encodeURIComponent(catValue));
    }
    if (
      typeof params.sub_category !== "undefined" &&
      hasValue(params.sub_category)
    ) {
      const subCategoryValue = Array.isArray(params.sub_category)
        ? params.sub_category
            .map((item) => String(item ?? "").trim())
            .filter((item) => item.length > 0)
            .join(";")
        : params.sub_category;
      qs.push("sub_category=" + encodeURIComponent(subCategoryValue));
    }

    const query = qs.length ? `?${qs.join("&")}` : "";
    const url = appendMarketQueryForMiddleEast(`/uae_mt_filters${query}`);
    const token = sessionStorage.getItem("accessToken")!;

    // Helper to run request
    const runRequest = async () => {
      return await httpClient.get(url, token);
    };

    try {
      // 1st attempt
      return await runRequest();
    } catch (err) {
      console.warn("First attempt failed, retrying...", err);
      // 2nd attempt
      try {
        return await runRequest();
      } catch (err2) {
        console.error("Second attempt also failed", err2);
        return getErrorMessage(err2);
      }
    }
  } catch (err) {
    console.error("Error building filter selection request", err);
    return getErrorMessage(err as any);
  }
}

// Utility to clear the cached filters (useful for testing or when you need to force-refresh)
export function clearFiltersCache() {
  (getFiltersApi as any)._cache = null;
  (getFiltersApi as any)._promise = null;
}
